const constants = {
  LOCAL_STORAGE_KEYS: {
    TOKEN: 'auth_token',
    REFRESH_TOKEN: 'auth_refresh_token',
    THEME: 'sliceal-theme',
    CHUNK_RELOAD_AT: 'chunk_reload_at',
  },
  PORTAL_CODE: 'AD',
} as const

export default constants
